import { Box, IconButton } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import SelectWinnerDialog from "./SelectWinnerDialog";
import { useState } from "react";

export default function ResultButton({ data, prizeDrawId }) {
    const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Box display="flex" alignItems="center" gap={1}>
        <IconButton
          sx={{
            border: "1px solid #1976d2",
            borderRadius: "8px",
            color: "#1976d2",
            width: 40,
            height: 40,
          }}
          onClick={() => setIsOpen(true)}
        >
          {data?.username ? <BorderColorIcon /> : <RefreshIcon />}
        </IconButton>
      </Box>
      <SelectWinnerDialog open={isOpen} handleClose={() => setIsOpen(false)} data={data} prizeDrawId={prizeDrawId} />
    </>
  );
}
